/**
 * useLatest Hook
 * 返回一个 ref，其 current 值始终指向最新的值
 * 用于避免闭包问题，替代多个 useEffect 同步 state 到 ref 的反模式
 */
import { useRef, useEffect } from 'react';

export function useLatest<T>(value: T): React.MutableRefObject<T> {
    const ref = useRef(value);
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref;
}
